/**
 *
 * NumberInput
 *
 */

import React, { forwardRef, useEffect, useState, useRef } from 'react';
import styles from './styles.module.css';
import { FlexButton } from 'components/common';

const NumberInput = forwardRef(function NumberInput(props, ref) {
  const { step = "1" } = props;

  let num = Math.random() + "";
  const [internalValue, setInternalValue] = useState(props.value);
  const [focused, setFocused] = useState(false);
  const localData = useRef({});
  const gen_id = useState(num);

  useEffect(() => {
    // Reset internal value if the external value has changed
    setInternalValue(props.value);
  }, [props.value])

  const handleOnChange = (e) => {
    setInternalValue(e.target.value);
    if (props.onChange) {
      props.onChange(e);
    }
  }

  const handleOnBlur = (e) => {
    setFocused(false);
    if (localData.current.keyListener) {
      document.removeEventListener('keydown', localData.current.keyListener);
    }
    let val = e.target.value;
    if (isNaN(parseFloat(val))) {
      val = '0';
    } else {
      val = parseFloat(val) + "";
    }
    setInternalValue(val);
    e.target.value = val;
    if (props.onBlur) {
      props.onBlur(e)
    }
  }


  const handleButtonFocus = (e) => {
    setFocused(true);
  }

  function handleIncrement(e, focus = true) {
    e.stopPropagation();
    e.preventDefault();
    if (focus) {
      document.getElementById(gen_id).focus();
    }

    let val = document.getElementById(gen_id).value;
    if (!isNaN(parseFloat(val))) {
      val = parseFloat((parseFloat(val) + parseFloat(step)).toFixed(2)) + ""
    }

    setInternalValue(val);
  }

  function handleDecrement(e, focus = true) {
    e.stopPropagation();
    e.preventDefault();
    if (focus) {
      document.getElementById(gen_id).focus();
    }
    let val = document.getElementById(gen_id).value;
    if (!isNaN(parseFloat(val))) {
      val = parseFloat((parseFloat(val) - parseFloat(step)).toFixed(2)) + ""
    }

    setInternalValue(val);
  }

  const handleOnFocus = (e) => {
    setFocused(true);
    if (localData.current.keyListener) {
      document.removeEventListener('keydown', localData.current.keyListener);
    }

    localData.current.keyListener = (e) => {
      if (e.keyCode === 38) {
        handleIncrement(e, false);
      } else if (e.keyCode === 40) {
        handleDecrement(e, false);
      }
    }

    document.addEventListener('keydown', localData.current.keyListener);
  }

  return <div className={styles.numberInputContainer}>
    <input
      id={gen_id}
      style={props.style}
      ref={ref}
      min='0'
      max='9999'
      value={internalValue}
      onFocus={handleOnFocus}
      onChange={handleOnChange}
      onBlur={handleOnBlur} />
    {props.showButtons !== false && <React.Fragment>
      <FlexButton blueprint icon='add' material className={styles.incrementButton} onClick={(e) => { handleIncrement(e); return false; }} />
      <FlexButton blueprint icon='remove' material className={styles.decrementButton} onClick={(e) => { handleDecrement(e); return false; }} />
    </React.Fragment>}
  </div>
})

NumberInput.propTypes = {};

export default NumberInput;
